import { Component, OnInit } from "@angular/core";
import { Notificaciones } from "src/app/models/Notificaciones";
import { AuthService } from "src/app/services/auth.service";
import { PerfilService } from "src/app/services/perfil.service";

@Component({
  selector: "app-notificaciones",
  templateUrl: "./notificaciones.component.html",
  styleUrls: ["./notificaciones.component.scss"],
})
export class NotificacionesComponent implements OnInit {
  authUserData: any;
  notifications: Notificaciones;
  constructor(
    private perfilService: PerfilService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.authService.userData$.subscribe((res: any) => {
      this.authUserData = res;
      this.getNotificaciones();
    });
  }

  getNotificaciones() {
    this.perfilService
      .getNotificaciones(this.authUserData.id, this.authUserData.auth_key)
      .subscribe((res: any) => {
        this.notifications = {
          id: res.id,
          id_user: res.id_user,
          mis_eventos: res.mis_eventos == 1 ? true : false,
          eventos_pupilos: res.eventos_pupilos == 1 ? true : false,
          cursos_aprendo: res.cursos_aprendo == 1 ? true : false,
          cursos_enseno: res.cursos_enseno == 1 ? true : false,
          created_at: res.created_at,
          updated_at: res.updated_at
        };
      });
  }

  updateNotificaciones() {
    const data = {
      id: this.authUserData.id,
      auth_key: this.authUserData.auth_key,
      mis_eventos: this.notifications.mis_eventos ? 1 : 0,
      eventos_pupilos: this.notifications.eventos_pupilos ? 1 : 0,
      cursos_aprendo: this.notifications.cursos_aprendo? 1 : 0,
      cursos_enseno: this.notifications.cursos_enseno? 1 : 0
    };
    this.perfilService
      .updateNotificaciones(
        this.authUserData.id,
        this.authUserData.auth_key,
        data
      )
      .subscribe((res: any) => {
        this.getNotificaciones();
      });
  }
}
